<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Trigger</h2>
      <br />
    
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="macAddress">
              <the-mask
                class="el-input__inner"
                v-model="query.macAddress"
                :masked="true"
                mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)"
                @keyup.enter.native="load"
                :tokens="hexTokens"
              />
            </el-form-item>
             <el-form-item label="Partner" prop="partner">
              <el-select
                @change="loadCustomers"
                v-model="query.partner"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in partnerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
              @change="load"
              filterable
                v-model="query.customer"
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="false" label="version">
              <el-input
                @keyup.enter.native="load"
                placeholder="Please input"
                v-model="query.version"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.triggers"
            class="border"
          >
            <el-table-column type="index" width="50" />
            <el-table-column prop="macAddress" label="macAddress" />
            <el-table-column
              prop="certificateId"
              label="Certificate Id"
              width="120px"
            >
              <template slot-scope="scope">
                <span @click="copyIdToClipboard(scope.row.certificateId)">
                  <abbr :title="scope.row.certificateId">{{
                    scope.row.certificateId
                  }}</abbr>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="registeredAt" label="registeredAt" />
            <el-table-column
              prop="customer"
              label="Customer"
            >
            </el-table-column>
              <el-table-column
              prop="partner"
              label="Partner"
            >
            </el-table-column>
            <el-table-column prop="version" label="Version" width="100px;" />
            <el-table-column prop="versionRequestedAt" label="Version Requested At" width="200px;" />
            <el-table-column label="Actions">
              <template slot-scope="scope">
              
              
                <el-button v-if="!editId" size="mini" @click="newCert(scope)"
                  >New Cert.</el-button
                >
               
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
    <el-dialog
      width="30%"
      title="Download Certificates"
      :visible.sync="showCertsForm"
    >
      <el-form
        v-if="certs"
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="230px"
        label-position="left"
        style="text-align: center"
      >
        <el-alert title="WARNING" type="" show-icon>
          You wont able to access this page, make sure you have downloaded
          required files from below</el-alert
        >
        <el-form-item label="CA Certificate" style="margin-top: 15px">
          <el-button @click="downloadCa('AWSRootCA1')">Download </el-button>
        </el-form-item>
        <el-form-item label="Device Certificate">
          <el-button @click="downloadCert('cert', certs.certificatePem)"
            >Download
          </el-button>
        </el-form-item>
        <el-form-item label="Device Private Key">
          <el-button @click="downloadCert('private', certs.keyPair.PrivateKey)"
            >Download
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";

export default {
  name: "Trigger",
  components: { TheMask },
  data() {
    let IsMacAddress = (rule, value, callback) => {
      if (
        !/^[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}$/g.test(
          value
        )
      ) {
        return callback(
          new Error("Please input proper mac address (ex: AB:CD:EF:12:34:56)")
        );
      }
      return callback();
    };
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      query: {
        macAddress: "",
        customer: "",
        partner: "",
        //version: "",
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
      editId: "",
      showForm: false,
      formLoading: false,
      certs: {},
      showCertsForm: false,
      form: {
        macAddress: "",
      },
      rules: {
        macAddress: [
          {
            validator: IsMacAddress,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getTriggers(this.query);
    this.getPartners();
    this.getCustomers();
  },
  computed: {
    ...mapState("trigger", ["searchResult", "loading"]),
    ...mapState("partner", ["customers","partners"]),

    customerSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
    
    partnerSelect() {
      return this.partners.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },

  },
  methods: {
     async loadCustomers(){
      this.query.customer = "";
      await this.getCustomers({partner:this.query.partner})
      await this.load()
    },
    load() {
      this.getTriggers(this.query);
    },
    downloadCa() {
      this.download(
        "AWSrootCA.txt",
        `-----BEGIN CERTIFICATE-----
MIIDQTCCAimgAwIBAgITBmyfz5m/jAo54vB4ikPmljZbyjANBgkqhkiG9w0BAQsF
ADA5MQswCQYDVQQGEwJVUzEPMA0GA1UEChMGQW1hem9uMRkwFwYDVQQDExBBbWF6
b24gUm9vdCBDQSAxMB4XDTE1MDUyNjAwMDAwMFoXDTM4MDExNzAwMDAwMFowOTEL
MAkGA1UEBhMCVVMxDzANBgNVBAoTBkFtYXpvbjEZMBcGA1UEAxMQQW1hem9uIFJv
b3QgQ0EgMTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBALJ4gHHKeNXj
ca9HgFB0fW7Y14h29Jlo91ghYPl0hAEvrAIthtOgQ3pOsqTQNroBvo3bSMgHFzZM
9O6II8c+6zf1tRn4SWiw3te5djgdYZ6k/oI2peVKVuRF4fn9tBb6dNqcmzU5L/qw
IFAGbHrQgLKm+a/sRxmPUDgH3KKHOVj4utWp+UhnMJbulHheb4mjUcAwhmahRWa6
VOujw5H5SNz/0egwLX0tdHA114gk957EWW67c4cX8jJGKLhD+rcdqsq08p8kDi1L
93FcXmn/6pUCyziKrlA4b9v7LWIbxcceVOF34GfID5yHI9Y/QCB/IIDEgEw+OyQm
jgSubJrIqg0CAwEAAaNCMEAwDwYDVR0TAQH/BAUwAwEB/zAOBgNVHQ8BAf8EBAMC
AYYwHQYDVR0OBBYEFIQYzIU07LwMlJQuCFmcx7IQTgoIMA0GCSqGSIb3DQEBCwUA
A4IBAQCY8jdaQZChGsV2USggNiMOruYou6r4lK5IpDB/G/wkjUu0yKGX9rbxenDI
U5PMCCjjmCXPI6T53iHTfIUJrU6adTrCC2qJeHZERxhlbI1Bjjt/msv0tadQ1wUs
N+gDS63pYaACbvXy8MWy7Vu33PqUXHeeE6V/Uq2V8viTO96LXFvKWlJbYK8U90vv
o/ufQJVtMVT8QtPHRh8jrdkPSHCa2XV4cdFyQzR1bldZwgJcJmApzyMZFo6IQ6XU
5MsI+yMRQ+hDKXJioaldXgjUkK642M4UwtBV8ob2xJNDd2ZhwLnoQdeXeGADbkpy
rqXRfboQnoZsG4q5WTP468SQvvG5
-----END CERTIFICATE-----`
      );
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    downloadCert(filename, text) {
      this.download(
        this.form.macAddress.replace(/:/, "_") + "_" + filename,
        text
      );
    },
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    ...mapActions("trigger", [
      "getTriggers",
      "createTrigger",
      "updateTrigger",
      "deleteTrigger",
      "newCertTrigger",
    ]),
    ...mapActions("partner", ["getPartners","getCustomers"]),
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
   
   
    newCert(scope) {
      this.$confirm(
        "This will permanently delete current certificate of the trigger and create new certificate. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$confirm(
            "!!!This will permanently delete current certificate of the gateway and create new certificate!!!. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => this.newCertTrigger(scope.row._id))
            .then((data) => {
              this.certs = data.certs;
              this.showCertsForm = true;
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => {
              this.formLoading = false;
              this.load();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "New certification canceled",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "New certification canceled",
          });
        });
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>